<script>
import { debounce } from "/vodalys/.jslibs/";
import { asyncAngularInvoke } from "/vodalys/vvuejs";
export default {
  translate25Context: ["whitelist"],
  components: {},
  props: ["component", "handler"],
  data: function () {
    return {
      search: "",
      pending: false,
      refreshInterval: null,
    };
  },
  computed: {
    items() {
      return Object.values(this.component.items || {});
    },
  },
  methods: {
    sortIcon(column) {
      if (this.component.select.order_column != column) return null;
      return this.component.select.order_direction == "ASC" ? "fa6-chevron-up" : "fa6-chevron-down";
    },
    duration(ms) {
      const hours = parseInt(ms / (3600 * 1000));
      const minutes = parseInt(ms / (60 * 1000)) % 60;
      const seconds = parseInt(ms / 1000) % 60;
      const parts = [];
      if (hours > 0) parts.push(hours + " " + this.$vt("hour(s)"));
      if (minutes > 0) parts.push(minutes + " " + this.$vt("minute(s)"));
      if (seconds > 0) parts.push(seconds + " " + this.$vt("second(s)"));
      return parts.join(" ");
    },
  },
  created() {
    this.removeAll = () => {
      var _zis = this;
      asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
        v17Modal.yesNo($rootScope, $rootElement.find("body"), {
          title: _zis.$vt("Remove all?"),
          message: _zis.$vt("Are you sure you want to remove all tracking items? This action cannot be undone."),
          yesType: "negative",
          yesLabel: _zis.$vt("Remove all"),
          yes: function () {
            return _zis.handler.action(_zis.component["#id"], "remove_all");
          },
          noLabel: _zis.$vt("Cancel"),
        });
      });
    };

    this.doSearch = debounce(() => {
      this.handler.action(this.component["#id"], "set_search", [this.search]);
    }, 300);

    this.refreshInterval = setInterval(() => {
      this.handler.action(this.component["#id"], "refresh");
    }, 30 * 1000);

    this.setOnlineOnly = (onlineOnly) => {
      this.handler.action(this.component["#id"], "set_online_only", [onlineOnly]);
    };

    this.sort = (column) => {
      this.handler.action(this.component["#id"], "sort", [
        column,
        this.component.select.order_direction == "ASC" ? "DESC" : "ASC",
      ]);
    };

    this.more = () => {
      if (this.pending || !this.component.more_to_load) return;

      const done = () => {
        this.pending = false;
      };
      this.pending = true;
      this.handler.action(this.component["#id"], "load_more").then(done, done);
    };
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
};
</script>

<template>
  <div class="f-whitelist-tracking">
    <div class="f-card f-content">
      <div class="f-toolbar">
        <div class="f-search">
          <f-icon class="f-icon" icon="fa6-magnifying-glass"></f-icon>
          <input
            @click.stop=""
            @input="doSearch()"
            type="search"
            v-model.trim="search"
            :placeholder="$vt('Search...')"
          />
          <f-button
            type="icon small"
            v-if="search"
            v-on:click.stop="
              search = '';
              doSearch();
            "
          >
            <f-icon icon="fa6-xmark"></f-icon>
          </f-button>
        </div>
        <button
          type="button"
          class="f-filter-online"
          :class="{ active: component.select.online_only }"
          @click="setOnlineOnly(!component.select.online_only)"
        >
          <span class="f-filter-online-dot"></span>
          {{ $vt("Online only") }}
        </button>
      </div>

      <div class="f-table">
        <div class="f-table-header">
          <div class="f-table-col address" @click="sort('address')">
            {{ $vt("Email address") }}
            <f-icon v-if="sortIcon('address')" :icon="sortIcon('address')"></f-icon>
          </div>
          <div class="f-table-col last-connection" @click="sort('last_connection')">
            {{ $vt("Last connection") }}
            <f-icon v-if="sortIcon('last_connection')" :icon="sortIcon('last_connection')"></f-icon>
          </div>
          <div class="f-table-col total-time-spent" @click="sort('total_time_spent')">
            {{ $vt("Total time spent") }}
            <f-icon v-if="sortIcon('total_time_spent')" :icon="sortIcon('total_time_spent')"></f-icon>
          </div>
        </div>
        <div class="f-table-body">
          <div class="f-empty" v-if="items.length == 0">
            <f-icon icon="fa6-clock"></f-icon>
            <div>{{ $vt("The list is empty") }}</div>
          </div>
          <f-sexy-scroll
            autoscroll-event
            :autoscroll-tolerance="100"
            @autoload="$event && more()"
          >
            <div
              class="f-table-line"
              v-for="(item, nid) in component.items"
              v-bind:key="item['#id']"
            >
              <div class="f-table-col address">
                <f-icon icon="fa6-user"></f-icon>
                <div class="f-whitelist-value">{{ item.address }}</div>
                <span class="f-badge-online" v-if="component.online && component.online[nid]">{{
                  $vt("Online")
                }}</span>
              </div>
              <div class="f-table-col last-connection">
                <span v-if="item.last_connection">{{
                  item.last_connection | angularFilter("EEE d MMM yyyy HH:mm", "date")
                }}</span>
              </div>
              <div class="f-table-col total-time-spent">
                <span v-if="item.total_time_spent">{{ duration(item.total_time_spent) }}</span>
              </div>
            </div>
            <div class="f-table-line more" v-if="component.more_to_load">
              <f-icon spin icon="fa6-circle-notch" v-if="pending"></f-icon>
            </div>
          </f-sexy-scroll>
        </div>
      </div>
    </div>

    <div class="f-side">
      <div class="f-card f-settings">
        <div class="f-settings-title">
          <f-icon icon="fa6-gear"></f-icon>
          {{ $vt("Settings") }}
        </div>

        <div class="f-settings-actions">
          <f-button type="secondary" :href="component.export_link"
            ><f-icon icon="fa6-download"></f-icon>{{ $vt("Export") }}</f-button
          >
          <f-button type="secondary" :href="component.export_complete_log"
            ><f-icon icon="fa6-download"></f-icon>{{ $vt("Export complete log") }}</f-button
          >

          <f-button type="negative" @click="removeAll()" :disabled="items.length == 0"
            ><f-icon icon="fa6-trash"></f-icon>{{ $vt("Remove all") }}</f-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.whitelist-tracking-ng-component {
  width: 100%;
}
</style>

<style lang="scss" scoped>
.f-whitelist-tracking {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;

  .f-card {
    background-color: var(--black);
    border-radius: 8px;
    box-shadow: 0 4px 16px #1616151a;
    padding: 16px;
  }

  .f-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1 1 auto;
    min-width: 0;
  }

  .f-side {
    flex: 0 0 380px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  @media (max-width: 1000px) {
    flex-direction: column-reverse;

    .f-side {
      flex: 0 0 auto;
    }
  }

  .f-settings {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .f-settings-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: bold;
      color: var(--white-a75);

      .f-icon {
        color: var(--primary);
      }
    }

    .f-button {
      width: 100%;
      justify-content: center;

      .f-icon {
        margin-right: 6px;
      }
    }

    .f-settings-actions {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  @keyframes f-live-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
  }

  .f-badge-online {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding: 2px 6px;
    border-radius: 4px;
    color: #fff;
    background: var(--statusNegative);

    &::before {
      content: "";
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #fff;
      animation: f-live-pulse 1.6s ease-in-out infinite;
    }
  }

  .f-toolbar {
    display: flex;
    align-items: center;
    gap: 16px;

    .f-filter-online {
      flex: 0 0 auto;
      height: 46px;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 0 16px;
      border: 1px solid var(--white-a10);
      border-radius: 6px;
      background: transparent;
      color: var(--white-a75);
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      transition: background-color ease 0.15s, border-color ease 0.15s, color ease 0.15s;

      &:hover {
        background: var(--white-a5);
      }

      .f-filter-online-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--white-a25);
      }

      &.active {
        border-color: var(--statusNegative);
        background: var(--statusNegative);
        color: #fff;

        .f-filter-online-dot {
          background: #fff;
          animation: f-live-pulse 1.6s ease-in-out infinite;
        }
      }
    }
    .f-search {
      flex: 1 1 auto;
      height: 46px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 0 8px 0 12px;
      border-radius: 6px;
      background: var(--white-a5);

      .f-icon {
        font-size: 16px;
        opacity: 0.6;
      }

      input {
        background-color: transparent;
        color: inherit;
        border: none;
        outline: none;
        flex: auto;
        margin-left: 10px;
        padding: 5px 0;
        font-size: 14px;
      }
    }
  }

  .f-table {
    flex: 1 1 auto;
    min-height: 400px;
    display: flex;
    flex-direction: column;

    .f-table-col {
      flex: 0 0 200px;
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 16px;

      &.address {
        flex: 1 1 auto;
      }
    }

    .f-table-header {
      display: flex;
      align-items: center;
      min-height: 48px;
      padding: 0 16px 0 0;
      border-bottom: 2px solid var(--white-a10);
      color: var(--white-a75);
      font-size: 14px;
      font-weight: bold;

      .f-table-col {
        cursor: pointer;
        user-select: none;

        &:hover {
          opacity: 0.75;
        }

        .f-icon {
          margin-left: auto;
        }
      }
    }

    .f-table-body {
      height: 0;
      flex: 1 1 100%;
      display: flex;
      flex-direction: column;

      .f-empty {
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        opacity: 0.5;

        > .f-icon {
          font-size: 32px;
          margin-bottom: 8px;
        }
      }

      .f-sexy-scroll {
        scrollbar-gutter: stable;
      }

      .f-table-line {
        display: flex;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid var(--white-a10);
        border-radius: 4px;
        color: var(--white-a75);
        font-size: 14px;
        transition: background-color ease 0.15s;

        &:hover {
          background-color: var(--white-a5);
        }

        .f-table-col.address {
          gap: 10px;

          .f-icon {
            color: var(--primary);
            font-size: 14px;
          }
        }

        .f-whitelist-value {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 0;
        }

        &.more {
          justify-content: center;
          height: 40px;
          border-bottom: none;
          opacity: 0.5;

          &:hover {
            background-color: transparent;
          }
        }
      }
    }
  }
}
</style>
